<script setup lang="ts">
import { computed } from 'vue'
import { useFilterStore } from 'Store/filterStore'
import { formatDate } from 'Common/utils/formatDate'

interface PropTypes {
  inspectionInstances: Array<any> //TODO typing
}

const props = defineProps<PropTypes>()
const filterStore = useFilterStore()

const currentInspectionUuid = computed(() => filterStore.filtersModel.inspectionInstance?.[0])

const getAircraftHistoryItemType = (item) => {
  if (item.inspectionInstanceUuid === currentInspectionUuid.value) return 'primary'
}

const handleTimelineItemClick = (item) => {
  if (item?.inspectionInstanceUuid) filterStore.filtersModel.inspectionInstance = [item?.inspectionInstanceUuid]
}
</script>

<template>
  <div class="p-6 flex flex-col shrink min-h-0 max-h-96">
    <h3 class="text-lg font-bold text-gray-700 mb-4 flex-1">Aircraft History</h3>
    <div class="el-timeline-wrapper overflow-y-auto je-scroll-area flex-2">
      <el-timeline>
        <el-timeline-item
          v-for="(item, index) in props.inspectionInstances"
          :key="index"
          :type="getAircraftHistoryItemType(item)"
          :timestamp="formatDate(item.startDate)"
          placement="bottom"
        >
          <a class="text-blue-600 hover:underline hover:cursor-pointer" @click="() => handleTimelineItemClick(item)">{{
            item.type
          }}</a>
        </el-timeline-item>
        <el-timeline-item>
          <span class="text-gray-400">Beginning of History</span>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>
<style>
.el-timeline-wrapper {
  /* set a min height to prevent cut off bottom of sidebar */
  min-height: 100px;
}
</style>
